export default "//file.bilionpass.com/japandx-web/0.0.1/static/icon_discount_shop.5943296e-80e5f7.svg";